export const REVERT_BASE_API_URL = process.env.REACT_APP_REVERT_BASE_API_URL || 'https://api.revert.dev';
